export default __webpack_public_path__ + "static/media/project-presentation.16cbcfd7.svg";